import { combineReducers } from "redux";
import { getTemplateDetailsReducer, getCountryreducer, getStatereducer, getCityreducer } from "./template-reducer";

export const rootReducer = combineReducers({
    getTemplateDetailsReducer,
    getCountryreducer,
    getStatereducer,
    getCityreducer
})